module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/lady-choices.40366c1c.svg";